export enum SupervisionValidationTypes {
    pilotExaminationV1EditSupervision = 'pilotExaminationV1EditSupervision',
    pilotExaminationV1EditSupervisionDraft = 'pilotExaminationV1EditSupervisionDraft',
    tcohV1EditSupervision = 'tcohV1EditSupervision',
    tcohV1EditSupervisionDraft = 'tcohV1EditSupervisionDraft',
    tcohV2EditSupervision = 'tcohV2EditSupervision',
    tcohV2EditSupervisionDraft = 'tcohV2EditSupervisionDraft',
    tcorV1EditSupervision = 'tcorV1EditSupervision',
    tcorV1EditSupervisionDraft = 'tcorV1EditSupervisionDraft',
    tfoV1EditSupervision = 'tfoV1EditSupervision',
    tfoV1EditSupervisionDraft = 'tfoV1EditSupervisionDraft',
    tiecgV1EditSupervision = 'tiecgV1EditSupervision',
    tiecgV1EditSupervisionDraft = 'tiecgV1EditSupervisionDraft',
    tpoV1EditSupervision = 'tpoV1EditSupervision',
    tpoV1EditSupervisionDraft = 'tpoV1EditSupervisionDraft',
}
